import React, { useState, useEffect } from "react";
import $ from "jquery";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";
import moment from "moment";
import { Input } from "reactstrap";
import { Icon } from "../../components/Component";

const DateRangePicker = ({ handleFilterDate, setMutationCall }) => {
  const [selectedRange, setSelectedRange] = useState("This Month"); // Default value

  useEffect(() => {
    // Set the default selected range as "This Month"
    // setSelectedRange("monthly");

    var start = moment().startOf("month"); // Yesterday
    var end = moment().endOf("month"); // Today

    // Initialize daterangepicker
    $("#reportrange").daterangepicker(
      {
        autoUpdateInput: false,
        startDate: start,
        endDate: end,
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        },
      },
      function (start, end) {
        let rangeLabel = "";

        // Compare the selected range to determine the correct label
        const today = moment().startOf("day");

        // "Today"
        if (start.isSame(today, "day") && end.isSame(today, "day")) {
          rangeLabel = "Today";
          handleFilterDate("today");
        }
        // "Yesterday"
        else if (
          start.isSame(moment().subtract(1, "days"), "day") &&
          end.isSame(moment().subtract(1, "days"), "day")
        ) {
          rangeLabel = "Yesterday";
          handleFilterDate("yesterday");
        }
        // "Last 7 Days"
        else if (
          start.isAfter(moment().subtract(7, "days"), "day") &&
          end.isSame(today, "day")
        ) {
          rangeLabel = "Last 7 Days";
          handleFilterDate("last_seven_days");
        }
        // "Last 30 Days"
        else if (
          start.isAfter(moment().subtract(30, "days"), "day") &&
          end.isSame(today, "day")
        ) {
          rangeLabel = "Last 30 Days";
          handleFilterDate("last_thirty_days");
        }
        // "This Month"
        else if (
          start.isSame(moment().startOf("month"), "day") &&
          end.isSame(moment().endOf("month"), "day")
        ) {
          rangeLabel = "This Month";
          handleFilterDate("this_month");
        }
        // "Last Month"
        else if (
          start.isSame(moment().subtract(1, "month").startOf("month"), "day") &&
          end.isSame(moment().subtract(1, "month").endOf("month"), "day")
        ) {
          rangeLabel = "Last Month";
          handleFilterDate("last_month");
        } else {
          // For any other custom date range
          rangeLabel = `${start.format("MM/DD/YYYY")} - ${end.format(
            "MM/DD/YYYY"
          )}`;
          handleFilterDate(rangeLabel);
        }
        // Update the input field with the label
        setSelectedRange(rangeLabel);

        setMutationCall();
      }
    );
  }, []);

  return (
    <div className="form-control-wrap w-md-auto">
      <div className="form-icon form-icon-right">
        <label htmlFor="reportrange">
          <Icon name="calender-date" />
        </label>
      </div>
      <Input
        id="reportrange"
        value={selectedRange}
				style={{
					"min-width": "220px"
				}}
      />
    </div>
  );
};

export default DateRangePicker;
